import React, { Component } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { ConnectedRouter } from 'react-router-redux';

// custom React containers
import Home from '../containers/Homepage';
import Work from '../containers/Work';
import Archive from '../containers/Archive';
import BTS from '../containers/BTS';
import SinglePage from '../containers/SinglePage';
import SinglePageTeam from '../containers/SinglePageTeam';
import SinglePageAbout from '../containers/SinglePageAbout';
import SinglePageContact from '../containers/SinglePageContact';
import SingleWork from '../containers/SingleWork';
import SingleBlog from '../containers/SingleBlog';
import SingleActueel from '../containers/SingleActueel';
import SingleAuthor from '../containers/SingleAuthor';
import SingleThemes from '../containers/SingleThemes';
import Consulting from '../containers/Consulting';
import BeFriendly from '../containers/BeFriendly';
import Themes from '../containers/Themes';

// Redux store
import store from '../store';

// Google Analytics ID
import ReactGA from 'react-ga';
ReactGA.initialize('UA-88840125-2', {
    gaOptions: {
        anonymizeIp: true,
    },
});

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
});

export default class App extends Component {
    componentWillMount() {
        ReactGA.set({ page: '/' });
        ReactGA.pageview('/');
    }

    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <BrowserRouter>
                        <Route
                            render={({ location }) => (
                                <CSSTransitionGroup
                                    transitionName={
                                        location.state
                                            ? location.state.transition
                                            : 'fade'
                                    }
                                    transitionEnterTimeout={1000}
                                    transitionLeaveTimeout={1000}>
                                    <Switch
                                        key={location.key}
                                        location={location}
                                        name={
                                            location.state
                                                ? location.state.name
                                                : false
                                        }>
                                        <Route
                                            exact
                                            path="/"
                                            component={Home}
                                        />
                                        <Route
                                            exact
                                            path="/work"
                                            component={Work}
                                        />
                                        <Route
                                            exact
                                            path="/archive"
                                            component={Archive}
                                        />
                                        <Route
                                            exact
                                            path="/behind-the-scenes"
                                            component={BTS}
                                        />
                                        <Route
                                            path="/people"
                                            component={SinglePageTeam}
                                        />
                                        <Route
                                            path="/about"
                                            component={SinglePageAbout}
                                        />
                                        <Route
                                            path="/be-friendly"
                                            component={BeFriendly}
                                        />
                                        <Route
                                            exact
                                            path="/contact"
                                            component={SinglePageContact}
                                        />
                                        <Route
                                            exact
                                            path="/work/:slug"
                                            component={SingleWork}
                                        />
                                        <Route
                                            exact
                                            path="/blog/:slug"
                                            component={SingleBlog}
                                        />
                                        <Route
                                            exact
                                            path="/actueel/:slug"
                                            component={SingleActueel}
                                        />
                                        <Route
                                            path="/posts/:slug"
                                            component={SingleActueel}
                                        />
                                        <Route
                                            path="/author/:slug"
                                            component={SingleAuthor}
                                        />
                                        <Route
                                            path="/themes/:slug"
                                            component={SingleThemes}
                                        />
                                        <Route
                                            exact
                                            path="/blog"
                                            render={() => (
                                                <Redirect to="/behind-the-scenes" />
                                            )}
                                        />
                                        <Route
                                            exact
                                            path="/actueel"
                                            render={() => (
                                                <Redirect to="/behind-the-scenes" />
                                            )}
                                        />
                                        <Route
                                            exact
                                            path="/posts"
                                            render={() => (
                                                <Redirect to="/behind-the-scenes" />
                                            )}
                                        />
                                        <Route
                                            path="/purpose-day"
                                            component={SinglePage}
                                        />
                                        <Route
                                            path="/online-consult"
                                            component={Consulting}
                                        />
                                        <Route
                                            path="/themes"
                                            component={Themes}
                                        />
                                        <Route component={SinglePage} />
                                    </Switch>
                                </CSSTransitionGroup>
                            )}
                        />
                    </BrowserRouter>
                </ConnectedRouter>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/App.jsx